import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldRoleVariables = Types.Exact<{
  worldId: Types.Scalars['Int'];
  publicKey: Types.Scalars['String'];
}>;


export type ApiWorldRole = { worldRole: Types.ApiWorldRole | null, world: { curator: { publicKey: Address } } | null };



export const ApiworldRoleDocument = /*#__PURE__*/ `
    query worldRole($worldId: Int!, $publicKey: String!) {
  worldRole(worldId: $worldId, publicKey: $publicKey)
  world(id: $worldId) {
    curator {
      publicKey: accountAddress
    }
  }
}
    `;

export const useWorldRole = <
      TData = ApiWorldRole,
      TError = ClientError
    >(
      variables: ApiWorldRoleVariables,
      options?: Omit<UseQueryOptions<ApiWorldRole, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldRole, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldRole, TError, TData>(
      {
    queryKey: ['worldRole', variables],
    queryFn: apiFetcher<ApiWorldRole, ApiWorldRoleVariables>(ApiworldRoleDocument, variables),
    ...options
  }
    )};

useWorldRole.getKey = (variables: ApiWorldRoleVariables) => ['worldRole', variables];

export const useInfiniteWorldRole = <
      TData = InfiniteData<ApiWorldRole>,
      TError = ClientError
    >(
      variables: ApiWorldRoleVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldRole, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldRole, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldRole, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['worldRole.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldRole, ApiWorldRoleVariables>(ApiworldRoleDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldRole.getKey = (variables: ApiWorldRoleVariables) => ['worldRole.infinite', variables];


useWorldRole.fetcher = (variables: ApiWorldRoleVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldRole, ApiWorldRoleVariables>(ApiworldRoleDocument, variables, options);
